module.exports = __webpack_public_path__ + "img/logo_mn3fr3.0ac79f98.png";